import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=20842983&scoped=true"
import script from "./tableView.vue?vue&type=script&lang=js"
export * from "./tableView.vue?vue&type=script&lang=js"
import style0 from "./tableView.vue?vue&type=style&index=0&id=20842983&prod&lang=scss&scoped=true"
import style1 from "./tableView.vue?vue&type=style&index=1&id=20842983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20842983",
  null
  
)

export default component.exports